module.exports = __webpack_public_path__ + "img/2-md.5d3a44e8.jpg";